import 'svelte/internal/disclose-version';
import 'svelte/internal/flags/legacy';
import * as $ from 'svelte/internal/client';
import { navigate, getPath } from '../../lib/router.svelte.ts';

var root_2 = $.from_svg(`<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" class="svelte-1ex3c8wyaom3u"><path d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-4 0a1 1 0 01-1-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 01-1 1h-2"></path></svg>`);
var root_3 = $.from_svg(`<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" class="svelte-1ex3c8wyaom3u"><circle cx="12" cy="12" r="9"></circle><path d="M12 7v5l3 3"></path></svg>`);
var root_4 = $.from_svg(`<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" class="svelte-1ex3c8wyaom3u"><path d="M12 3C10 7 6 9 6 13a6 6 0 0012 0c0-4-4-6-6-10z"></path></svg>`);
var root_5 = $.from_svg(`<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" class="svelte-1ex3c8wyaom3u"><circle cx="12" cy="5" r="1.5"></circle><circle cx="12" cy="12" r="1.5"></circle><circle cx="12" cy="19" r="1.5"></circle></svg>`);
var root_1 = $.from_html(`<button><div class="tab-icon svelte-1ex3c8wyaom3u"><!></div> <span class="tab-label svelte-1ex3c8wyaom3u"> </span></button>`);
var root = $.from_html(`<nav class="bottom-nav safe-bottom svelte-1ex3c8wyaom3u"></nav>`);

function BottomNav($$anchor, $$props) {
	$.push($$props, false);

	const tabs = [
		{ path: '/', label: 'Home', icon: 'home' },
		{ path: '/log', label: 'Log', icon: 'log' },
		{ path: '/storage', label: 'Storage', icon: 'storage' },
		{ path: '/more', label: 'More', icon: 'more' }
	];

	function isActive(tabPath) {
		const path = getPath();

		if (tabPath === '/') return path === '/';

		return path.startsWith(tabPath);
	}

	$.init();

	var nav = root();

	$.each(nav, 5, () => tabs, $.index, ($$anchor, tab) => {
		var button = root_1();
		let classes;
		var div = $.child(button);
		var node = $.child(div);

		{
			var consequent = ($$anchor) => {
				var svg = root_2();

				$.append($$anchor, svg);
			};

			var consequent_1 = ($$anchor) => {
				var svg_1 = root_3();

				$.append($$anchor, svg_1);
			};

			var consequent_2 = ($$anchor) => {
				var svg_2 = root_4();

				$.append($$anchor, svg_2);
			};

			var consequent_3 = ($$anchor) => {
				var svg_3 = root_5();

				$.append($$anchor, svg_3);
			};

			$.if(node, ($$render) => {
				if ($.get(tab).icon === 'home') $$render(consequent); else if ($.get(tab).icon === 'log') $$render(consequent_1, 1); else if ($.get(tab).icon === 'storage') $$render(consequent_2, 2); else if ($.get(tab).icon === 'more') $$render(consequent_3, 3);
			});
		}

		$.reset(div);

		var span = $.sibling(div, 2);
		var text = $.child(span, true);

		$.reset(span);
		$.reset(button);

		$.template_effect(
			($0, $1) => {
				classes = $.set_class(button, 1, 'nav-tab svelte-1ex3c8wyaom3u', null, classes, $0);
				$.set_attribute(button, 'aria-label', $.get(tab).label);
				$.set_attribute(button, 'aria-current', $1);
				$.set_text(text, $.get(tab).label);
			},
			[
				() => ({ active: isActive($.get(tab).path) }),
				() => isActive($.get(tab).path) ? 'page' : undefined
			]
		);

		$.delegated('click', button, () => navigate($.get(tab).path));
		$.append($$anchor, button);
	});

	$.reset(nav);
	$.append($$anchor, nav);
	$.pop();
}

if (import.meta.hot) {
	BottomNav = $.hmr(BottomNav);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-1ex3c8wyaom3u');
		BottomNav[$.HMR].update(module.default);
	});
}

export default BottomNav;

$.delegate(['click']);
import "bun-svelte:BottomNav.svelte-hcpywy7f4npv-style.css";